<script>

/**
 * Automodal 
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'

import { archetype, automodalHandler } from './archetype'

export default {
    name: 'automodal',
    props: {
        sedesId: {
            type: [String, Number]
        },
        conceptId: {
            type: [String, Number],
        }
    },
    data: () => {
        return {
            form: {
                id: null
            },
            asides: {
                sedes: []
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        formArchetypeMD5() {
            return md5(JSON.stringify(this.cArchetype))
        },
        cArchetype() {
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if (!_.isArray(itemsRow)) {
                    updated.push(this.handleItem(itemsRow));
                    return
                }
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    case 'lunch_cedes_id':
                        item.options = _.concat([{
                            value: null,
                            group: 'General',
                            text: 'Todos'
                        }], _.map(_.clone(this.asides.sedes), item => {
                            return {
                                value: item.id,
                                group: item.cede_tipo,
                                text: item.cede_titulo
                            }
                        }))
                        if(this.sedesId){
                            item.readonly = true
                        }
                        break;
                }
            }
            return item;
        },
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                this.asides.sedes = asides.sedes
                // this.asides.distribuidores = asides.distribuidores
            }
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
            if(this.sedesId)
                this.form.lunch_cedes_id = this.sedesId
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        }
    },
    watch: {
        'form.id'() {
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" size="sm" 
        :form-id="form.id" 
        :form-archetype="cArchetype"
        :handler="getHandler()" 
        :allow-aside="false" 
        :allow-delete="true" 
        :form-key="formArchetypeMD5" 
        @refresh="refresh()"
        @defined="checkAsides()" @display="onDisplay" @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="7">
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
        </b-col>
        <b-col slot="bottom" v-if="false">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>